<template>
    <v-snackbar v-model="exibir" :color="corAlerta" right top :timeout="timeout">
        <v-container fluid>
            <v-layout row>
                <v-flex xs12 class="mb-2">
                    <span>{{ mensagem }}</span>
                    <br>
                    <a v-if="link && link.url" :href="link.url" :target="!link.redirecionar?'_blank':''">{{link.texto}}</a>
                </v-flex>
                <v-flex xs2 align-self-center>
                    <v-btn flat text @click="fechar" class="pt-0">
                        <v-icon small flat depressed color="white">close</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>
            <v-layout row justify-space-between>
                <v-flex xs9>
                    <ul>
                        <li v-for="excecao in excecoes" :key="excecao.index">
                            {{ excecao }}
                        </li>
                    </ul>
                </v-flex>
            </v-layout>
        </v-container>
    </v-snackbar>
</template>

<script>
export default {
    name: 'Alert',
    props: {
        exibir: {
            type: Boolean,
            default: false
        },
        mensagem: {
            type: String,
            required: true
        },
        excecoes: {
            type: Array,
            default: () => []
        },
        link:{
            type: Object,
            default: null
        },
        timeout: {
            type: Number,
            default: 0
        },
        isAlertaAmarelo:{
            type: Boolean,
            default: false
        }
    },
    computed:{
        corAlerta(){
            if(this.isAlertaAmarelo === true) return '#FFB900'
            return '#FF5252'
        }
    },
    methods: {
        fechar() {
            this.$emit('fechar')
        }
    }
}
</script>

<style lang="stylus" scoped>
    .az-template-default .container
        height 100%
        padding 0
        background-color unset
    a
        font-weight bold
        color white
</style>
